import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

export type SincoCompany = {
  IdOrigen: number;
  IdEmpresa: number;
  Nombre: string;
  Estado: boolean;
  Imagenes?: string;
};

type Props = {
  companies: SincoCompany[];
  selectedCompany: SincoCompany | null;
  onSelect: (company: SincoCompany) => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

const EmpresaSelector = ({
  companies,
  selectedCompany,
  onSelect,
  onConfirm,
  isLoading,
}: Props) => {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="flex min-h-[200px] items-center justify-center py-12">
          <Spinner />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Seleccionar empresa</CardTitle>
        <CardDescription>
          Elige la empresa de SINCO con la que deseas trabajar para el módulo de recaudo
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
          {companies
            .filter((e) => e.Estado)
            .map((company) => (
              <button
                key={`${company.IdOrigen}-${company.IdEmpresa}`}
                type="button"
                onClick={() => onSelect(company)}
                className={cn(
                  "flex min-h-[44px] cursor-pointer items-center rounded-md border px-4 py-3 text-left transition-colors",
                  selectedCompany?.IdOrigen === company.IdOrigen &&
                    selectedCompany?.IdEmpresa === company.IdEmpresa
                    ? "border-palomma-primary bg-palomma-primary/5"
                    : "border-gray-200 hover:bg-gray-50"
                )}
              >
                <span className="font-medium text-gray-900">{company.Nombre}</span>
              </button>
            ))}
        </div>
        <Button
          onClick={onConfirm}
          disabled={!selectedCompany}
        >
          Continuar con esta empresa
        </Button>
      </CardContent>
    </Card>
  );
};

export default EmpresaSelector;
